import { GatewayChangeEmail } from "@conformite/gateway";
import { userSession } from "@src/session/UserSession";

export class GatewayChangeEmailAPI {
  public static async changeEmail(
    payload: GatewayChangeEmail.ChangeEmailType
  ): Promise<string> {
    const { data } = await userSession.axiosInstance.post<string>(
      GatewayChangeEmail.changeEmailUrl,
      payload
    );
    return data;
  }

  public static async verify(payload: GatewayChangeEmail.VerifyEmailType) {
    await userSession.axiosInstance.post<string>(
      GatewayChangeEmail.verifyEmailUrl,
      payload
    );
  }
}
